import * as THREE from "three";
import goldPrizeCalculator from "../goldPlateUtils";
export function colorChangeOfMetal(setColor, globalState) {
    if (globalState.globalMaterial?.default && globalState.groupRef.current) {
        globalState.globalMaterial.default.color.set(setColor);
        globalState.setColor(setColor);
    } else {
        console.error("Materials or mesh not found.");
    }
}

export function setTargetToCenterOffTheScreen(globalState) {
    let bboxForAlphabets = new THREE.Box3().setFromObject(
        globalState.groupRef.current
    );
    let center = bboxForAlphabets.getCenter(new THREE.Vector3());
    globalState.controlsRef.current.target.x = center.x;
    globalState.controlsRef.current.target.y = 0;
}

export function setGlbPosWithBbx(inObj3D, inGlb) {
    const bbox = new THREE.Box3().setFromObject(inObj3D);
    const center = bbox.getCenter(new THREE.Vector3());

    // Try 3 positions on the X axis: left, center, right
    const xPositions = [
        bbox.min.x + (bbox.max.x - bbox.min.x) * 0.48, // left
        center.x, // center
        bbox.max.x - (bbox.max.x - bbox.min.x) * 0.52, // right
    ];

    const raycaster = new THREE.Raycaster();
    let lowestIntersect = null;

    for (let x of xPositions) {
        const origin = new THREE.Vector3(x, bbox.min.y - 1, 0); // cast slightly below
        raycaster.set(origin, new THREE.Vector3(0, 1, 0)); // cast upwards

        const intersects = raycaster.intersectObject(
            inObj3D.getObjectByName("3dText")
        );
        if (intersects.length > 0) {
            const point = intersects[0].point;
            if (!lowestIntersect || point.y < lowestIntersect.y) {
                lowestIntersect = point;
            }
        }
    }

    // Fallback: center of bounding box if no intersection found
    const finalPos =
        lowestIntersect || new THREE.Vector3(center.x, center.y, 0);
    inGlb.position.set(finalPos.x, finalPos.y, 0);
}

export const findDiamondIntersection = (obj, raycaster) => {
    if (!obj) return null;

    const intersects = raycaster.intersectObject(obj, true); // check descendants
    if (intersects.length > 0) {
        return {
            object: intersects[0].object,
            point: intersects[0].point.clone(), // global position
        };
    }

    for (let child of obj.children) {
        const found = findDiamondIntersection(child, raycaster);
        if (found) return found;
    }

    return null;
};

export function removeAllAlphabets(inObj3D) {
    while (
        inObj3D.getObjectByName("3dText") ||
        inObj3D.getObjectByName("pointSphere") ||
        inObj3D.getObjectByName("clonedDiamond") ||
        inObj3D.getObjectByName("innerMesh") ||
        inObj3D.getObjectByName("tube")
    ) {
        if (inObj3D.getObjectByName("3dText")) {
            removeObjWithChildren(inObj3D.getObjectByName("3dText"));
        }
        if (inObj3D.getObjectByName("pointSphere")) {
            removeObjWithChildren(inObj3D.getObjectByName("pointSphere"));
        }
        if (inObj3D.getObjectByName("clonedDiamond")) {
            removeObjWithChildren(inObj3D.getObjectByName("clonedDiamond"));
        }
        if (inObj3D.getObjectByName("innerMesh")) {
            removeObjWithChildren(inObj3D.getObjectByName("innerMesh"));
        }
        if (inObj3D.getObjectByName("tube")) {
            removeObjWithChildren(inObj3D.getObjectByName("tube"));
        }
    }
}
export function removeDotDiamond(globalState) {
    const dotDiamonds = globalState.groupRef.current.children.filter(
        (child) => child.name === "clonedDiamond"
    );
    dotDiamonds.forEach((dotDiamond) => {
        dotDiamond.visible = false;
    });
    globalState.setNoOfDotDiamond(0);
    globalState.setPrices((prevPrices) => ({
        ...prevPrices,
        dotDiamondPrice: 0,
    }));
}

export function removeObjWithChildren(obj) {
    if (obj.children.length > 0) {
        for (var x = obj.children.length - 1; x >= 0; x--) {
            removeObjWithChildren(obj.children[x]);
        }
    }
    if (obj.isMesh) {
        obj.geometry.dispose();
        obj.material.dispose();
    }
    if (obj.parent) {
        obj.parent.remove(obj);
    }
}

function addRefSphere(inPoint, inObj3D, inColor) {
    let sphereGeometry = new THREE.SphereGeometry(0.5, 32, 32);
    let sphereMaterial = new THREE.MeshPhysicalMaterial({ color: inColor });
    let sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
    sphere.position.set(inPoint[0], inPoint[1], 0);
    sphere.name = "pointSphere";
    inObj3D.add(sphere);
    sphere.visible = false;
}
window.addRefSphere = addRefSphere;

function addSphereForRef(globalState) {
    let sphere = new THREE.SphereGeometry(1, 32, 32);
    let material = new THREE.MeshBasicMaterial({ color: 0xffff00 });
    let sphereMesh = new THREE.Mesh(sphere, material);
    globalState.groupRef.current.add(sphereMesh);
    let bboxForAlphabets = new THREE.Box3().setFromObject(
        globalState.groupRef.current
    );
    let center = bboxForAlphabets.getCenter(new THREE.Vector3());
    sphereMesh.position.set(center.x + 120, center.y, center.z + 50);
    globalState.cameraRef.current.position.copy(sphereMesh.position);
}
window.addSphereForRef = addSphereForRef;
export function offsetPoints(points, offset = { x: 0, y: 0 }) {
    const offsetPoints = points.map((point) => [
        point[0] + offset.x,
        point[1] + offset.y,
    ]);
    const offsetVectorPoints = offsetPoints.map(
        (point) => new THREE.Vector3(point[0], point[1], 0)
    );
    return offsetVectorPoints;
}

export function createMeshFromPoints(offsetPoints) {
    // Check for NaN or Infinity values in offsetPoints
    const isValid = offsetPoints.every(
        (point) =>
            Number.isFinite(point.x) &&
            Number.isFinite(point.y) &&
            Number.isFinite(point.z)
    );

    if (!isValid) {
        console.error(
            "Invalid points in offsetPoints. Aborting mesh creation."
        );
        return null;
    }

    // Create a new BufferGeometry
    const geometry = new THREE.BufferGeometry();

    // Convert the offsetPoints array to a flat Float32Array
    const vertices = new Float32Array(
        offsetPoints.flatMap((point) => [point.x, point.y, point.z])
    );

    // Create a buffer attribute and set the vertices
    const positionAttribute = new THREE.BufferAttribute(vertices, 3); // 3 for x, y, and z
    geometry.setAttribute("position", positionAttribute);

    const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    const mesh = new THREE.Mesh(geometry, material);
    return mesh;
}
export function pathToShapeGeometry(path) {
    let shapes = path.toShapes(true);
    const extrudeSettings = {
        depth: 0.46,
        bevelEnabled: true,
        bevelSegments: 2,
        bevelSize: 0.052,
        bevelThickness: 0.1,
    };
    let geometry = new THREE.ExtrudeGeometry(shapes, extrudeSettings);
    let material = new THREE.MeshStandardMaterial({
        side: THREE.DoubleSide,
        depthWrite: false,
    });
    const mesh = new THREE.Mesh(geometry, material);
    mesh.rotateX(Math.PI);
    mesh.position.z += 5;
    return mesh;
}
export function OffsetContour(contour, offset) {
    let result = [];

    offset = new THREE.BufferAttribute(new Float32Array([offset, 0, 0]), 3);

    for (let i = 0; i < contour.length; i++) {
        let v1 = new THREE.Vector2().subVectors(
            contour[i - 1 < 0 ? contour.length - 1 : i - 1],
            contour[i]
        );
        let v2 = new THREE.Vector2().subVectors(
            contour[i + 1 === contour.length ? 0 : i + 1],
            contour[i]
        );
        let angle = v2.angle() - v1.angle();
        let halfAngle = angle * 0.5;

        let hA = halfAngle;
        let tA = v2.angle() + Math.PI * 0.5;

        let shift = Math.tan(hA - Math.PI * 0.5);
        let shiftMatrix = new THREE.Matrix4().set(
            1,
            0,
            0,
            0,
            -shift,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        );

        let tempAngle = tA;
        let rotationMatrix = new THREE.Matrix4().set(
            Math.cos(tempAngle),
            -Math.sin(tempAngle),
            0,
            0,
            Math.sin(tempAngle),
            Math.cos(tempAngle),
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        );

        let translationMatrix = new THREE.Matrix4().set(
            1,
            0,
            0,
            contour[i].x,
            0,
            1,
            0,
            contour[i].y,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        );

        let cloneOffset = new THREE.Vector3(
            offset.getX(0),
            offset.getY(0),
            offset.getZ(0)
        );

        cloneOffset.applyMatrix4(shiftMatrix);
        cloneOffset.applyMatrix4(rotationMatrix);
        cloneOffset.applyMatrix4(translationMatrix);

        result.push(new THREE.Vector2(cloneOffset.x, cloneOffset.y));
    }

    let shape = new THREE.Shape(result);
    let geometry = new THREE.ExtrudeGeometry(shape, {
        depth: 0.46,
        bevelEnabled: true,
        bevelSegments: 2,
        bevelSize: 0.052,
        bevelThickness: 0.1,
    });

    return geometry;
}

export const initialCamPos = (globalState) => {
    const cameraPosX = goldPrizeCalculator.getPWidth() / 2;
    const cameraPosY = -goldPrizeCalculator.getPHeight() / 2;
    return new Promise((resolve) => {
        globalState.cameraRef.current.position.set(cameraPosX, cameraPosY, 70);
        requestAnimationFrame(() => {
            resolve();
        });
    });
};

export async function calculatePrize(inWeightGrams) {
    if (typeof inWeightGrams !== "number" || inWeightGrams <= 0) {
        throw new Error("Invalid weight");
    }

    try {
        // Check localStorage for cached price data
        const cachedData = localStorage.getItem("goldPricing");
        const now = Date.now();
        const twelveHours = 12 * 60 * 60 * 1000; // 12 hours in milliseconds

        let price;
        
        // Use cached price if it exists and is less than 12 hours old
        if (cachedData) {
            const parsedData = JSON.parse(cachedData);
            const cacheAge = now - parsedData.timestamp;
            
            if (cacheAge < twelveHours) {
                console.log("Using cached gold price:", parsedData.price, "(age:", Math.round(cacheAge / 1000 / 60), "minutes)");
                price = parsedData.price;
            } else {
                console.log("Cache expired, fetching fresh gold price");
                price = await fetchAndCacheGoldPrice();
            }
        } else {
            console.log("No cache found, fetching gold price from API");
            price = await fetchAndCacheGoldPrice();
        }
        
        console.log("Calculating price with gold rate:", price, "for weight:", inWeightGrams, "grams");

        const total = price * inWeightGrams;
        return total;
    } catch (error) {
        throw new Error("Failed to calculate prize: " + error.message);
    }
}

// Helper function to fetch and cache gold price
async function fetchAndCacheGoldPrice() {
    try {
        const response = await fetch(
            "https://haref-backend.hexacoder.co/metals/pricing"
        );
        if (!response.ok) {
            throw new Error(
                `Failed to fetch gold pricing: ${response.statusText}`
            );
        }

        const pricingData = await response.json();
        const price = pricingData.data.rates["18K"];

        if (!price) {
            throw new Error("18K gold price not found in API response");
        }

        // Cache the price with timestamp
        const cacheData = {
            price: price,
            timestamp: Date.now(),
            lastUpdated: new Date().toISOString(),
        };

        localStorage.setItem("goldPricing", JSON.stringify(cacheData));

        return price;
    } catch (error) {
        // If API fails, try to use cached data even if expired
        const cachedData = localStorage.getItem("goldPricing");
        if (cachedData) {
            const parsedData = JSON.parse(cachedData);
            console.warn(
                "Using expired cached price due to API failure:",
                error.message
            );
            return parsedData.price;
        }
        throw error;
    }
}

export async function fetchFontFile(fontFileKey) {
    const url = `${process.env.REACT_APP_FILE_BASE_URL}${fontFileKey}`;
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to fetch font: ${response.statusText}`);
    }
    return await response.arrayBuffer();
}

// Gold price per ounce × 121÷1333.3 +185 × the estimated average weight + 15% = the final(
